<template>
  <div>
    <header class="header" :class="authRoute ? 'header--login' : ''">
      <div class="container">
        <nav class="header-nav">
          <a
            v-if="authRoute"
            class="header-logo header-logo--desktop"
            :href="marketingSiteConfig.baseUrl"
            rel="noopener noreferrer"
            target="_blank"
          >
            <TheOrganizationLogo height="12" inverse />
          </a>
          <AppLink v-else class="header-logo header-logo--desktop" to="/" @click="handleItemClick({ path: '/' })">
            <TheOrganizationLogo />
          </AppLink>

          <div v-if="authRoute" class="header-nav__login">
            <div class="header-nav__login-left">
              <a
                class="header-nav__link"
                :href="marketingSiteConfig.aboutUsUrl"
                rel="noopener noreferrer"
                target="_blank"
                >About</a
              ><a
                class="header-nav__link"
                :href="marketingSiteConfig.membershipsOptionsUrl"
                rel="noopener noreferrer"
                target="_blank"
                >Membership</a
              ><a
                class="header-nav__link"
                :href="marketingSiteConfig.contactUrl"
                rel="noopener noreferrer"
                target="_blank"
                >Contact</a
              >
            </div>
            <div class="header-nav__login-right">
              <a
                class="header-nav__link header-nav__link--right"
                :href="marketingSiteConfig.membershipsOptionsUrl"
                rel="noopener noreferrer"
                target="_blank"
                >Join Us</a
              >
            </div>
          </div>

          <div v-if="$route.name && $route.name !== 'login'" class="btns header-btns--desktop">
            <button v-if="isAuth && showFilterButton" class="filter-btn" @click="showFilter">
              <TheFilterIcon />
            </button>

            <RouterLink v-if="isAuth && destinationMapRoute" :to="destinationMapRoute">
              <TheGeoMarkerIcon width="16" />
            </RouterLink>

            <button v-if="isAuth" class="inbox-btn" @click="showMsgInbox">
              <InboxMsgIcon />
              <span v-show="unreadAppMessagesCount" class="inbox-btn__count">{{ unreadAppMessagesCount }}</span>
            </button>

            <RouterLink v-if="isAuth" class="search-btn--desktop" :to="{ name: 'search' }">
              <TheSearchIcon />
            </RouterLink>

            <button
              v-if="isAuth"
              aria-controls="appMainMenu"
              :aria-expanded="isMainMenuShown"
              aria-label="Toggle navigation"
              class="menu-btn--desktop"
              @click="showMainMenu"
            >
              <TheMenuHamburgerIcon />
            </button>
          </div>
        </nav>
      </div>
    </header>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AppConfig from '@/config';

import TheOrganizationLogo from '@/components/logos/TheOrganizationLogo.vue';
import InboxMsgIcon from '@/components/icons/InboxMsgIcon.vue';
import TheArrowHorizIcon from '@/components/icons/TheArrowHorizIcon.vue';
import TheFilterIcon from '@/components/icons/TheFilterIcon.vue';
import TheSearchIcon from '@/components/icons/TheSearchIcon.vue';
import TheMenuHamburgerIcon from '@/components/icons/TheMenuHamburgerIcon.vue';
import { sendGaEvent } from '@/helpers/ga/gaSend';
import MenuOpenedGaEvent from '@/helpers/ga/events/MenuOpenedGaEvent';
import AppLink from '@/components/AppLink.vue';
import NavItemClickedGaEvent from '@/helpers/ga/events/NavItemClickedGaEvent';
import { isAuthRoute, routeToDestinationMap } from '@/helpers/routerHelper';
import TheGeoMarkerIcon from '@/components/icons/TheGeoMarkerIcon.vue';

export default {
  name: 'AppHeader',
  components: {
    TheGeoMarkerIcon,
    AppLink,
    TheMenuHamburgerIcon,
    TheSearchIcon,
    TheFilterIcon,
    TheArrowHorizIcon,
    InboxMsgIcon,
    TheOrganizationLogo,
  },
  data() {
    return {
      isDataFiltered: true,
      marketingSiteConfig: AppConfig.get('marketingSite'),
      needFilter: false,
      toggle: false,
    };
  },
  computed: {
    ...mapState([
      'isAuth',
      'isMainMenuShown',
      'isMobileScreenExclude768',
      'unreadAppMessagesCount',
    ]),
    authRoute() {
      return isAuthRoute(this.$route.name);
    },
    showFilterButton() {
      return this.$store.state.filter.showFilterButton;
    },
    destinationMapRoute() {
      return this.$route.name === 'destination'
        ? routeToDestinationMap(this.$route.params.id, this.$route.params.slug)
        : null;
    },
  },
  methods: {
    handleItemClick(link) {
      if (link.path !== this.$route.path) {
        sendGaEvent(new NavItemClickedGaEvent(link.path, link.title).addHeaderNavigation());
      }
    },
    showMainMenu() {
      this.$store.dispatch('showMainMenu', true);
      sendGaEvent(new MenuOpenedGaEvent());
    },
    showFilter() {
      this.$store.dispatch('filter/toggleFilter', true);
    },
    showMsgInbox() {
      this.$store.dispatch('showMsgInbox', true);
    },
  },
};
</script>

<style lang="scss" scoped>
.back-btn {
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
}
</style>
